import { ImportedRow } from '../../convert-excel-to-impact-answers';

export class ImportMappingError extends Error {
  constructor(field: string, value: string, row: ImportedRow) {
    super(
      `[${field}] value not recognized: "${value}". Row: ${JSON.stringify(row)}`,
    );
    this.name = 'ImportMappingError';
  }
}
